export const nightgalePageConfig = {
  "title": "New",
  "titleCN": "新进",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/engagement/register",
  "defaultTab": "new",
  "tabList": [
    {
      "id": "new",
      "tabName": "New",
      "tabNameCN": "新进",
      "isHaveNotification": true,
      "notificationPath": "/engagement/register",
      "path": "/engagement/register",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200601",
        "pageName": "engagementNew",
        "extInfo": "engagementNew",
        "pagePath": "/engagement/register"
      },
      "filters": [
        {
          "name": "NewFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/register",
          "componentList": [
            {
              "name": "NewUsersTrendCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/register/total_new_users",
                  "isSingle": false
                }
              },
              "children": [
                {
                  "name": "TotalNewUsersCo",
                  "className": "margin-t-20",
                  "type": "view",
                  "enName": "Accumulated New Users",
                  "cnName": "累计新增用户",
                  "props": {
                    "config": {
                      "type": "total_users"
                    }
                  },
                  "children": []
                },
                {
                  "name": "TotalNewUsersCo",
                  "className": "margin-t-20",
                  "type": "view",
                  "enName": "Daily New Users Trend",
                  "cnName": "每日新增用户趋势",
                  "props": {
                    "config": {
                      "type": "new_users"
                    }
                  },
                  "children": []
                }
              ]
            },
            {
              "name": "NewUsersTrendCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/engagement/register/reg_distribution",
                  "isSingle": false
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "type": "layout",
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "NewUsersDistributionCo",
                          "type": "view",
                          "props": {
                            "config": {
                              "isLastDay": false,
                              "type": "country"
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "NewUsersDistributionCo",
                          "type": "view",
                          "props": {
                            "config": {
                              "isLastDay": false,
                              "type": "platform"
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "type": "layout",
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "type": "view",
                  "data": {
                    "regionDataType": "country",
                    "tabOrder": [
                      "country",
                      "region",
                      "os"
                    ]
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "type": "view",
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/engagement/register/new_distribution",
                          "metric": "new",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          },
                          "comConfig": {
                            "isHaveBar": true,
                            "isHaveLine": true,
                            "isHavePie": true,
                            "isHaveShare": true
                          },
                          "chartDataKey": "new_register_date_list",
                          "tableDataKey": "new_register_list"
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}